import {
	API_GET_ALL_CONTACT_COMMENT,
	API_ADMIN_GET_ALL_CONTACT_COMMENT,
	API_ADMIN_GET_CONTACT_COMMENT,
	ADMIN_INIT_NEW_CONTACT_COMMENT,
	ADMIN_RESET_FOCUS_CONTACT_COMMENT,
	API_ADMIN_POST_CONTACT_COMMENT,
	API_ADMIN_PATCH_CONTACT_COMMENT,
	API_ADMIN_DELETE_CONTACT_COMMENT,
} from 'actions/contactComment';

export function getAllContactComments() {
	return {
		type: API_GET_ALL_CONTACT_COMMENT,
		payload: {
			request: {
				url: `/contactComments`
			}
		}
	};
}

export function adminGetAllContactComments() {
	return {
		type: API_ADMIN_GET_ALL_CONTACT_COMMENT,
		payload: {
			request: {
				url: `/admin/contactComments`
			}
		}
	};
}

export function adminGetContactComment(contactComment) {
	return {
		type: API_ADMIN_GET_CONTACT_COMMENT,
		payload: {
			request: {
				url: `/admin/contactComments/${contactComment.id}`
			}
		}
	};
}

export function adminPostContactComment(contactComment) {
	return {
		type: API_ADMIN_POST_CONTACT_COMMENT,
		payload: {
			request: {
				url: `/admin/contactComments`,
				method: 'POST',
				data: contactComment
			}
		}
	};
}

export function adminPatchContactComment(contactComment) {
	return {
		type: API_ADMIN_PATCH_CONTACT_COMMENT,
		payload: {
			request: {
				url: `/admin/contactComments/${contactComment.id}`,
				method: 'PATCH',
				data: contactComment
			}
		}
	};
}

export function adminDeleteContactComment(contactComment) {
	return {
		type: API_ADMIN_DELETE_CONTACT_COMMENT,
		payload: {
			request: {
				url: `/admin/contactComments/${contactComment.id}`,
				method: 'DELETE'
			}
		}
	};
}

export function initNewContactComment() {
	return {
		type: ADMIN_INIT_NEW_CONTACT_COMMENT
	};
}

export function resetFocusContactComment() {
	return {
		type: ADMIN_RESET_FOCUS_CONTACT_COMMENT
	};
}
